export const MYWEP_TAGGING = {

    PushAIInteractionEvent: function (eventAction: string, eventName: string) {
        MYWEP_TAGGING.PushEvent("AI tool Interactions", eventAction, eventName );
    },

    PushEvent: function (eventCategory: string, eventAction: string, eventName: string) {

        if (window._paq) {
            window._paq.push(['trackEvent', eventCategory, eventAction, eventName]);
        }
    }
};